import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

const styles = theme => ({
  root: {
    ...theme.components.popover,
  },
  description: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px`,
  },
  actions: {
    maxWidth: 360,
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

const DeleteAdminConfirm = ({ classes, data, handleClose }) => (
  <div className={classes.root}>
    <Typography variant="h1">Remove Admin</Typography>
    <Typography className={classes.description}>
      Are you sure you want to remove {data.user.fullName}
      <br />
      from your project as an admin?
    </Typography>
    <div className={classes.actions}>
      <SubmitButton
        size="medium"
        color="primary"
        variant="secondary"
        onClick={handleClose}>
        Cancel
      </SubmitButton>
      <SubmitButton
        size="medium"
        color="primary"
        variant="primary"
        onClick={data.onConfirm}>
        Confirm
      </SubmitButton>
    </div>
  </div>
)

DeleteAdminConfirm.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
  handleClose: PropTypes.func,
}

export default withStyles(styles)(DeleteAdminConfirm)



// WEBPACK FOOTER //
// ./src/components/molecules/DeleteAdminConfirm.js